export const REPLAY_FORMAT_RRWEB = 'rrweb';
export const REPLAY_FORMAT_LEGACY = 'legacy';

function isRrwebEvent(event) {
    if (!event || typeof event !== 'object') return false;
    return typeof event.timestamp === 'number' && typeof event.type === 'number';
}

export function detectReplayPayloadFormat(payload) {
    if (!payload || typeof payload !== 'object') return REPLAY_FORMAT_LEGACY;
    if (payload.format === REPLAY_FORMAT_RRWEB) return REPLAY_FORMAT_RRWEB;
    if (Array.isArray(payload.events) && payload.events.length && isRrwebEvent(payload.events[0])) {
        return REPLAY_FORMAT_RRWEB;
    }
    return REPLAY_FORMAT_LEGACY;
}

export function mergeReplayPayloads(payloads) {
    const sorted = (payloads || [])
        .filter((p) => p && typeof p === 'object')
        .sort((a, b) => Number(a.chunk_index ?? 0) - Number(b.chunk_index ?? 0));
    if (!sorted.length) {
        return { format: REPLAY_FORMAT_LEGACY, events: [], viewport: null };
    }

    const format = detectReplayPayloadFormat(sorted[0]);

    if (format === REPLAY_FORMAT_RRWEB) {
        const events = [];
        for (const payload of sorted) {
            if (!Array.isArray(payload.events)) continue;
            for (const event of payload.events) {
                if (isRrwebEvent(event)) events.push(event);
            }
        }
        events.sort((a, b) => (a.timestamp ?? 0) - (b.timestamp ?? 0));
        return { format: REPLAY_FORMAT_RRWEB, events };
    }

    const events = [];
    let timeOffset = 0;
    let viewport = sorted[0]?.viewport ?? null;
    for (const payload of sorted) {
        if (payload.viewport) viewport = payload.viewport;
        const chunkEvents = Array.isArray(payload.events) ? payload.events : [];
        for (const event of chunkEvents) {
            events.push({
                ...event,
                t: (Number(event.t) || 0) + timeOffset,
            });
        }
        const chunkMax = chunkEvents.reduce((max, e) => Math.max(max, Number(e.t) || 0), 0);
        timeOffset += chunkMax + 1;
    }
    events.sort((a, b) => (a.t ?? 0) - (b.t ?? 0));
    return { format: REPLAY_FORMAT_LEGACY, events, viewport };
}

export async function fetchReplayPayloadFromUrl(url) {
    const res = await fetch(url, { mode: 'cors' });
    if (!res.ok) {
        throw new Error(`Could not load recording (${res.status})`);
    }
    return res.json();
}

export async function loadSessionReplayFromChunkUrls(chunkDescriptors) {
    const sorted = [...(chunkDescriptors || [])].sort(
        (a, b) => Number(a.index ?? a.chunkIndex ?? 0) - Number(b.index ?? b.chunkIndex ?? 0)
    );
    if (!sorted.length) {
        return { format: REPLAY_FORMAT_LEGACY, events: [], viewport: null };
    }
    const payloads = await Promise.all(
        sorted.map(async (chunk) => fetchReplayPayloadFromUrl(chunk.url))
    );
    return mergeReplayPayloads(payloads);
}
